import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { TenantProvider } from '@/contexts/TenantContext';

import App from './App';
import { i18nReady } from './i18n';
import './styles/index.css';

// Não inicializar modo escuro aqui - será aplicado apenas no AppLayout quando o usuário estiver logado

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {},
  },
});

// Log de erros globalmente (removido - React Query v5 não suporta onError nas defaultOptions)

// Renderizar só depois do i18next estar pronto — chamar t() antes disso
// (mesmo com recursos estáticos, a inicialização é assíncrona) faz `t()`
// devolver a própria chave em vez do valor traduzido; com
// `returnObjects: true` isso quebra qualquer `.map()` subsequente com
// "is not a function" em vez de um texto errado visível.
void i18nReady.finally(() => {
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <TenantProvider>
              <App />
            </TenantProvider>
            <Toaster richColors position="top-right" />
          </BrowserRouter>
        </QueryClientProvider>
      </ErrorBoundary>
    </React.StrictMode>,
  );
});
